import {
  APPROVED_CATEGORIES_LIST_REQUEST,
  APPROVED_CATEGORIES_LIST_RESPONSE,
  ADD_CATEGORY_REQUEST,
  EDIT_CATEGORY_REQUEST,
  GET_CATEGORY_DETAILS_REQUEST,
  GET_CATEGORY_DETAILS_RESPONSE,
  DELETE_CATEGORY_REQUEST,
  CATEGORY_SUB_CATEGORIES_LIST_REQUEST,
  CATEGORY_SUB_CATEGORIES_LIST_RESPONSE,
  REQUESTS_CATEGORIES_LIST_REQUEST,
  REQUESTS_CATEGORIES_LIST_RESPONSE,
  GET_CATEGORY_REQUEST_DETAILS_REQUEST,
  GET_CATEGORY_REQUEST_DETAILS_RESPONSE,
  REJECT_CATEGORY_REQUEST,
  ACCEPT_CATEGORY_REQUEST
} from "./types";

export const approvedCategoriesListRequest = (payload) => ({
  type: APPROVED_CATEGORIES_LIST_REQUEST,
  payload
});

export const approvedCategoriesListResponse = (payload) => ({
  type: APPROVED_CATEGORIES_LIST_RESPONSE,
  payload
});

export const addCategoryRequest = (payload) => ({
  type: ADD_CATEGORY_REQUEST,
  payload
});

export const editCategoryRequest = (payload) => ({
  type: EDIT_CATEGORY_REQUEST,
  payload
});

export const getCategoryDetailsRequest = (payload) => ({
  type: GET_CATEGORY_DETAILS_REQUEST,
  payload
});

export const getCategoryDetailsResponse = (payload) => ({
  type: GET_CATEGORY_DETAILS_RESPONSE,
  payload
});
export const deleteCategoryRequest = (payload) => ({
  type: DELETE_CATEGORY_REQUEST,
  payload
});

export const categorySubCategoriesListRequest = (payload) => ({
  type: CATEGORY_SUB_CATEGORIES_LIST_REQUEST,
  payload
});

export const categorySubCategoriesListResponse = (payload) => ({
  type: CATEGORY_SUB_CATEGORIES_LIST_RESPONSE,
  payload
});

export const requestsCategoriesListRequest = (payload) => ({
  type: REQUESTS_CATEGORIES_LIST_REQUEST,
  payload
});

export const requestsCategoriesListResponse = (payload) => ({
  type: REQUESTS_CATEGORIES_LIST_RESPONSE,
  payload
});

export const getCategoryRequestDetailsRequest = (payload) => ({
  type: GET_CATEGORY_REQUEST_DETAILS_REQUEST,
  payload
});

export const getCategoryRequestDetailsResponse = (payload) => ({
  type: GET_CATEGORY_REQUEST_DETAILS_RESPONSE,
  payload
});

export const rejectCategoryRequest = (payload) => ({
  type: REJECT_CATEGORY_REQUEST,
  payload
});

export const acceptCategoryRequest = (payload) => ({
  type: ACCEPT_CATEGORY_REQUEST,
  payload
});
